import { BaseRepository } from '../BaseRepository';
import { BFF_ENDPOINTS, type BffEndpoint } from '../../endpoints/BffEndpoints';
import type { HttpResponse } from '../../http/HttpClient';
import type { CampaignsListResponse } from '../../models/bff/Campaign';
import { BffApiClient } from '../../clients/BffApiClient';

const NAME = 'campaigns';

export class CampaignRepository extends BaseRepository<BffEndpoint> {
  static override name = NAME;

  constructor() {
    super(BffApiClient.getInstance());
  }

  list(): Promise<HttpResponse<CampaignsListResponse>> {
    return this.apiClient.get<CampaignsListResponse>(BFF_ENDPOINTS.CAMPAIGN_LIST);
  }
}

declare module '../Repositories' {
  export interface Repositories {
    [NAME]: CampaignRepository;
  }
}
